import { useContext, useRef, useState } from "react";
import { GeaoContext } from "../GeaoContextProvider";
import Papa from "papaparse";
import { initialize } from "../../../api/onboarding";

export default function useAgentRosterInitializer() {
    const { agencyInterview } = useContext(GeaoContext);
    const [progress, setProgress] = useState(0);
    const errors = useRef([]);

    let rowCount = 1;
    let completedRows = 0;

    function handleRow(csvRow) {
        if (!Array.isArray(csvRow) || csvRow.length !== 3) {
            rowCount--;
            return; // Skip improperly formatted rows (last row is usually empty, for example)
        }

        if (
            csvRow[0] === "Last Name" &&
            csvRow[1] === "First Name" &&
            csvRow[2] === "Business Email Address"
        ) {
            rowCount--;
            return; // Skip header row.
        }

        return initialize({
            identityType: "Agent",
            interview: {
                questionAnswers: {
                    LastName: { answer: csvRow[0] },
                    FirstName: { answer: csvRow[1] },
                    BusinessEmailAddress: { answer: csvRow[2] },
                    WasStartedByAgentRosterUpload: { answer: "true" }
                },
                relationships: [{ type: "ParentAgency", interviewId: agencyInterview.interviewId }]
            }
        }).catch(errorResponse => {
            errors.current = [...errors.current, { Response: errorResponse, FirstName: csvRow[1], LastName: csvRow[0], BusinessEmailAddress: csvRow[2] }];
        }).finally(_ => {
            completedRows++;
            setProgress(Math.round((completedRows / rowCount) * 100));
        });
    }

    function initializeFromCsv(csv) {
        setProgress(0);
        completedRows = 0;
        errors.current = [];

        if (!csv.name.endsWith(".csv")) {
            errors.current = [{ invalidFileType: true }];
            return Promise.resolve();
        }

        return new Promise(resolve => {
            Papa.parse(csv, {
                complete: results => {
                    resolve(results);
                }
            });
        }).then(results => {
            if (results.errors.length > 0) {
                console.log("CSV parsing errors:", results.errors);
                errors.current = [{ invalidFileType: true }];
                return;
            }

            rowCount = results.data.length;

            const emails = results.data.map(row => row[2]);
            const duplicateEmails = emails.filter((email, index) => emails.indexOf(email) !== index);

            if (duplicateEmails.length !== 0) {
                errors.current = [{ duplicateEmails }];
            } else {
                return Promise.all(results.data.map(row => handleRow(row)));
            }
        });
    }

    return { initializeFromCsv, progress, errors };
}